import { Component, OnInit, inject } from '@angular/core';
import { AuthenticationContextDatasourceService } from '../../../backend/datasource/authentication-context-datasource.service';
import { ThemeHandlerService } from '../../service/theme-handler.service';
import { Theme } from '../../../backend/model/theme.model';
import { IDCardModule } from '@inera/ids-angular/components/card';
import { NgTemplateOutlet } from '@angular/common';
import { ThemeType } from '../../../backend/model/theme-type';
import { IDLinkModule } from '@inera/ids-angular/components/link';

@Component({
  selector: 'idp-mtls-no-certificate',
  imports: [IDCardModule, IDLinkModule, NgTemplateOutlet],
  templateUrl: './mtls-no-certificate.component.html',
  styleUrls: ['./mtls-no-certificate.component.scss']
})
export class MtlsNoCertificateComponent implements OnInit {
  private authenticationContextDatasource = inject(AuthenticationContextDatasourceService);
  private themeHandler = inject(ThemeHandlerService);

  private readonly X509_ROUTE = 'x509';

  public theme: Theme;
  public themeType = ThemeType;

  ngOnInit(): void {
    this.themeHandler.getTheme().subscribe(theme => {
      this.theme = theme.value.value;
    });
  }

  public getMethodTypeInstructionsText(): string {
    if (this.authenticationContextDatasource.getIsSignature()) {
      return 'signeringsförsöket';
    } else {
      return 'inloggningsförsöket';
    }
  }

  public getMethodTypeText(): string {
    if (this.authenticationContextDatasource.getIsSignature()) {
      return 'underskriften';
    } else {
      return 'inloggningen';
    }
  }

  public retry(): void {
    window.location.href = this.getRedirect('retry');
  }

  public cancel(): void {
    window.location.href = this.getRedirect('cancel');
  }

  private getRedirect(path: string): string {
    let url = `${window.location.origin}/${this.authenticationContextDatasource.getIdp()}/${this.X509_ROUTE}/${path}`;

    const sessionId = this.authenticationContextDatasource.getSessionId();
    if (sessionId?.length > 0) {
      url += `?id=${sessionId}`;
    }

    return url;
  }
}
